/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PatchedWaterQualityCustomizedResultAreaGeometry } from "./PatchedWaterQualityCustomizedResultAreaGeometry";
import {
  PatchedWaterQualityCustomizedResultAreaGeometryFromJSON,
  PatchedWaterQualityCustomizedResultAreaGeometryFromJSONTyped,
  PatchedWaterQualityCustomizedResultAreaGeometryToJSON,
  PatchedWaterQualityCustomizedResultAreaGeometryToJSONTyped,
} from "./PatchedWaterQualityCustomizedResultAreaGeometry";
import type { SubsetsEnum } from "./SubsetsEnum";
import {
  SubsetsEnumFromJSON,
  SubsetsEnumFromJSONTyped,
  SubsetsEnumToJSON,
  SubsetsEnumToJSONTyped,
} from "./SubsetsEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface WaterQualityCustomizedResultArea
 */
export interface WaterQualityCustomizedResultArea {
  /**
   *
   */
  readonly url?: string;
  /**
   * Name of the customized results area.
   */
  name: string;
  /**
   * Subsets of the customized results area. Valid subsets are: 1D, 2D, 1D2D, GW.
   */
  subsets: Array<SubsetsEnum>;
  /**
   *
   */
  geometry: PatchedWaterQualityCustomizedResultAreaGeometry;
}

/**
 * Check if a given object implements the WaterQualityCustomizedResultArea interface.
 */
export function instanceOfWaterQualityCustomizedResultArea(
  value: object
): value is WaterQualityCustomizedResultArea {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("subsets" in value) || value["subsets"] === undefined) return false;
  if (!("geometry" in value) || value["geometry"] === undefined) return false;
  return true;
}

export function WaterQualityCustomizedResultAreaFromJSON(
  json: any
): WaterQualityCustomizedResultArea {
  return WaterQualityCustomizedResultAreaFromJSONTyped(json, false);
}

export function WaterQualityCustomizedResultAreaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WaterQualityCustomizedResultArea {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    name: json["name"],
    subsets: (json["subsets"] as Array<any>).map(SubsetsEnumFromJSON),
    geometry: PatchedWaterQualityCustomizedResultAreaGeometryFromJSON(json["geometry"]),
  };
}

export function WaterQualityCustomizedResultAreaToJSON(
  json: any
): WaterQualityCustomizedResultArea {
  return WaterQualityCustomizedResultAreaToJSONTyped(json, false);
}

export function WaterQualityCustomizedResultAreaToJSONTyped(
  value?: Omit<WaterQualityCustomizedResultArea, "url"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    subsets: (value["subsets"] as Array<any>).map(SubsetsEnumToJSON),
    geometry: PatchedWaterQualityCustomizedResultAreaGeometryToJSON(value["geometry"]),
  };
}
